var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPerms(_vm.perms))?_c('router-link',[_c('el-link',{attrs:{"type":_vm.type,"size":_vm.size,"icon":"el-icon-edit"}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d58e63f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Link/DIcon.vue
// module id = null
// module chunks = 